<h2>Parsing Financial Model</h2>
<mat-dialog-content>

  <mat-progress-bar *ngIf="!financialModel" mode="buffer"></mat-progress-bar>

  <p *ngIf="!financialModel">
    File is being parsed, please be patient. <strong>Be sure to stay on this window during this process!</strong>
  </p>
  <p *ngIf="hasFailed" class="financial-model-warning-message">
    Financial Model could not be parsed. Please try again with a different file.
  </p>
  <p *ngIf="financialModel && !hasFailed && financialModel?.errors?.length <= 0">
    File successfully parsed. Please be aware that the current financial values will only be saved when clicking
    the "Save" button in the Financial Model tab after confirming this popup.
  </p>

  <section *ngIf="!isProjectCreation && financialModel?.needExplanation">

    <p class="financial-model-warning-message">
      The changes that will be made in uploading this financial model will result in changes to the
      'Project - Total Installed Capacity (MW),' which is classed as a Key Data Field in DigiRES. To proceed with
      saving these changes to the Key Data Field you must provide an explanation for why this change has been made.
    </p>

    <digires-text-input [required]="true"
                        [formGroup]="formGroup"
                        formCtrlName="reason"
                        placeholder="Reason for change"
                        error="Please enter a reason"
                        [textarea]="true"
                        fixedRowCount="6"
    ></digires-text-input>

  </section>

  <ng-container *ngIf="financialModel?.errors?.length > 0">

    <p class="financial-model-warning-message">
      Please Note: The list below shows the data fields in the financial model that couldn’t be read when it was
      uploaded, however this may be the desired outcome, for example where the project only contains Onshore Wind
      then it is expected that fields relating to Solar would not be updated.
    </p>
    <p class="financial-model-warning-message">
      {{financialModel.errors.length}} data fields could not be filled using this Financial Model file.
    </p>
    <p>
      These fields are listed below with the reason why they could not be filled.
      The unfilled data fields can be populated manually.
    </p>

    <table>
      <tr>
        <th class="financial-model-warning-property-name">Financial Model Data Field</th>
        <th>Data Validation Check</th>
      </tr>

      <tr *ngFor="let error of financialModel.errors">
        <td class="financial-model-warning-property-name">{{error.propertyName}}</td>
        <td>
          {{error.errorMessage}}
          <mat-icon class="tooltip-icon" svgIcon="tooltip" matTooltipPosition="right"
                    matTooltip="{{financialModelErrorToTooltip[error.errorType]}}"
          ></mat-icon>
        </td>
      </tr>
    </table>

  </ng-container>

</mat-dialog-content>
<mat-dialog-actions *ngIf="!financialModel">
  <button class="btnNeutral" mat-button [mat-dialog-close]="false">Cancel</button>
</mat-dialog-actions>
<mat-dialog-actions *ngIf="financialModel">
  <button class="btnNeutral" mat-button [mat-dialog-close]="false">Cancel</button>
  <button class="btnPositive" mat-button
          [disabled]="financialModel.needExplanation && formGroup.invalid"
          [mat-dialog-close]="createConfirmResponse()">Confirm</button>
  <p>
    NOTE: This change and explanation will only be saved into DigiRES once the 'Save' button on the Financial Model tab has
    been clicked. If the 'Reset' button on the Financial Model tab is clicked then this will restore the previous value in
    the Financial Model tab and the explanation will be deleted.
  </p>
</mat-dialog-actions>
